import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { AnnouncementDialogState } from './announcement-dialog-reducer';
import {
  fetchAnnouncement,
  setDontShowAgain,
} from './announcement-dialog-actions';
import {
  selectAnnouncement,
  selectAnnouncementsLoaded,
  selectValidAnnouncement,
} from './announcement-dialog-selector';

@Injectable({
  providedIn: 'root',
})
export class AnnouncementDialogFacade {
  constructor(private store: Store<AnnouncementDialogState>) {}

  selectAnnouncement$ = this.store.pipe(select(selectAnnouncement));

  selectAnnouncementLoaded$ = this.store.pipe(
    select(selectAnnouncementsLoaded)
  );

  selectValidAnnouncement$ = this.store.pipe(select(selectValidAnnouncement));

  fetchAnnouncement() {
    this.store.dispatch(fetchAnnouncement());
  }

  setDontShowAgain(dontShowAgain: boolean) {
    this.store.dispatch(setDontShowAgain({ dontShowAgain }));
  }
}
